import { memo, useCallback } from "react";
import {
  TRelationshipGroupItemForm,
  relationshipGroupItemSchema,
} from "./relationshipGroupItemSchema";
import { Treturn, useFetch } from "@4uhub/lib4uhub";
import {
  createUBusRelationshipGroupItem,
  getUBusRelationshipGroupItemById,
  updateUBusRelationshipGroupItemById,
} from "../../../../../../../services/uBusRelationshipGroupItem.service";
import { RelationShipFormScreen } from "../../../../../../../screens/RelationshipsScreens/RelationShipFormScreen/RelationShipFormScreen";
import { IRelationshipGroupItemProps } from "./models";

export const UBusRelationshipGroupItem = memo(
  ({
    id,
    uBusRelationshipGroupId,
    uBusAutomationCode,
    onBackButton,
  }: IRelationshipGroupItemProps) => {
    const { sendRequest: save, loading: sLoading } = useFetch(
      createUBusRelationshipGroupItem,
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateUBusRelationshipGroupItemById,
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getUBusRelationshipGroupItemById,
    );

    const saveHandler = (v: TRelationshipGroupItemForm) =>
      save({
        ...v,
        originValue: v.default ? "*" : v.originValue,
        _4uBusRelationshipGroupId: uBusRelationshipGroupId ?? "",
        _4uBusRelationshipTypeId: v.uBusRelationshipType?.id,
        destinityName: v.destinyName,
        destinityValue: v.destinyValue,
      });

    const updateHandler = (v: TRelationshipGroupItemForm, id: string) =>
      update({
        item: {
          ...v,
          originValue: v.default ? "*" : v.originValue,
          _4uBusRelationshipGroupId: uBusRelationshipGroupId ?? "",
          _4uBusRelationshipTypeId: v.uBusRelationshipType?.id,
          destinityName: v.destinyName,
          destinityValue: v.destinyValue,
        },
        id: id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TRelationshipGroupItemForm>> => {
        const { data, success } = await get(id);

        if (data) {
          const newData: TRelationshipGroupItemForm = {
            ...data,
            originName: data.originName ?? "",
            originValue: data.originValue ?? "",
            destinyName: data.destinityName ?? "",
            destinyValue: data.destinityValue ?? "",
            uBusRelationshipType: data._4uBusRelationshipType,
          };
          return { data: newData, success: true };
        }
        return { data, success };
      },
      [get],
    );

    const loading = sLoading || uLoading || gLoading;

    return (
      <RelationShipFormScreen<TRelationshipGroupItemForm>
        id={id}
        isTag
        uBusAutomationCode={uBusAutomationCode}
        onBackButton={onBackButton}
        saveHandler={saveHandler}
        updateHandler={updateHandler}
        getHandler={getHandler}
        schema={relationshipGroupItemSchema}
        loading={loading}
      />
    );
  },
);
